import React from 'react';
import _ from 'underscore';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';

import { formatDate } from 'utilities/common';
import Datagrid from 'ui/components/data/grid';

const CardLegs = ({
  data,
  keys,
  moveUp,
  moveDown,
  active,
  onClick,
  status,
  privilege,
}) => {
  const isShouldReceive = (l) => {
    if (l?.is_receive) {
      const x = _.filter(l?.jobs, (j, i) => {
        return j.status === 'delivered' || j.status === 'unreceived';
      });

      return x.length > 0;
    }

    return false;
  };

  return (
    <div
      className={cn(
        'border-bottom p-2 cursor-pointer',
        active ? 'bg-primary-lt' : 'bg-white'
      )}
    >
      <div className="row align-items-center text-secondary">
        {status === 'new' && privilege && (
          <div className="col-1 pe-0">
            <div className="d-flex flex-column gap-2">
              <button
                type="button"
                className="btn btn-sm btn-primary p-0"
                onClick={() => moveUp(data?.id)}
              >
                <Fi.FiChevronUp size={22} />
              </button>
              <button
                type="button"
                className="btn btn-sm btn-primary p-0"
                onClick={() => moveDown(data?.id)}
              >
                <Fi.FiChevronDown size={22} />
              </button>
            </div>
          </div>
        )}
        <div
          className={cn(status === 'new' ? 'col-11' : 'col-12')}
          onClick={() => onClick(data)}
        >
          <div className="px-2">
            <div className="position-relative">
              <div className="table-col">
                <small className="info text-uppercase">
                  {keys}. {data?.type?.replace('_point', '')} POINT
                </small>
                <div className="fs-8 fw-bold text-uppercase">
                  {isShouldReceive(data) && (
                    <Fi.FiGift className="me-2" color="red" />
                  )}
                  {data?.location?.name}
                </div>
                <small className="info text-uppercase">
                  {data?.location?.region?.district_name},{' '}
                  {data?.location?.region?.regency_name},{' '}
                  {data?.location?.region?.province_name}
                </small>
              </div>

              {data?.status !== 'new' && (
                <div className="position-absolute top-0 end-0">
                  <span className={`badge status-${data?.status}-lt`}>
                    {data?.status?.replace('_', ' ')}
                  </span>
                </div>
              )}
            </div>

            <div className="row mt-2">
              <div className="col-6">
                <Datagrid
                  title="Waktu Keberangkatan"
                  value={formatDate(data?.atd_at)}
                />
              </div>
              <div className="col-6">
                <Datagrid
                  title="Waktu Kedatangan"
                  value={formatDate(data?.ata_at)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardLegs;
